export const STATUS_ORDER = ["Not launched", "Lost", "Booked", "Open"];
export const normalizedStatusOrder = STATUS_ORDER.map(s => s.toLowerCase()); 